const initialState = {
  permissions: [],
};

export default initialState;
